import { render, staticRenderFns } from "./JourneyAssignCandidates.vue?vue&type=template&id=4385a782&lang=pug&"
import script from "./JourneyAssignCandidates.vue?vue&type=script&lang=js&"
export * from "./JourneyAssignCandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports